export const TOUR_STEPS = {
  buyer: [
    { selector: '[data-testid="buyer-tab-dashboard"]', title: 'Tableau de bord',
      text: "Votre vue d'ensemble : commandes récentes, dépenses et solde CREDI'SCOP en un coup d'œil." },
    { selector: '[data-testid="buyer-tab-orders"]', title: 'Commandes',
      text: 'Suivez toutes vos commandes B2B, leurs statuts et leurs documents.' },
    { selector: '[data-testid="buyer-tab-invoices"]', title: 'Factures',
      text: 'Retrouvez et réglez vos factures marchandises et vos reçus de paiement.' },
    { selector: '[data-testid="buyer-tab-consultations"]', title: 'Consultations',
      text: 'Lancez des consultations compétitives (COOP\'ACT) auprès des vendeurs.' },
    { selector: '[data-testid="buyer-tab-transport"]', title: "Transport LOGI'SCOP",
      text: 'Émettez vos Ordres de Transport, suivez les livraisons et payez vos factures transport.' },
    { selector: '[data-testid="ai-guide-fab"]', title: "Oracle",
      text: 'Je reste disponible ici à tout moment : questions, montants exacts, raccourcis et dictée vocale !' },
  ],
  admin: [
    { selector: '[data-testid="superadmin-tab-dashboard"]', title: 'Dashboard',
      text: "Vue d'ensemble : KPIs, rapport hebdo, RCR FOGEDOM et alertes de l'écosystème." },
    { selector: '[data-testid="superadmin-tab-accounting"]', title: 'Comptabilité',
      text: 'Journal comptable, exports CSV/Excel et trésorerie consolidée 30/60/90 jours.' },
    { selector: '[data-testid="superadmin-tab-logicoop"]', title: 'LOGICOOP',
      text: 'Pilotage transport : OT, factures, litiges, avoirs, synthèses mensuelles et opérateurs.' },
    { selector: '[data-testid="superadmin-tab-users"]', title: 'Membres',
      text: 'Gérez les comptes vendeurs, acheteurs et leurs rôles.' },
    { selector: '[data-testid="ai-guide-fab"]', title: "Oracle",
      text: 'Demandez-moi la santé financière, les impayés ou les points de friction des membres.' },
  ],
  member: [
    { selector: '[data-testid="ai-guide-fab"]', title: "Oracle",
      text: 'Je vous guide : PASS Vie Chère, wallet UC, retraits en Lolo Point… posez-moi vos questions !' },
  ],
  detaillant: [
    { selector: '[data-testid="offer-quick-lots"]', title: 'Lots prêts à déposer',
      text: 'Cliquez un produit du catalogue de base : lot ×3 pré-rempli. Re-cliquez pour retirer la sélection, cliquez un autre pour la remplacer.' },
    { selector: '[data-testid="detaillant-offer-form"]', title: "Dépôt d'offre",
      text: 'Confirmez chaque article (quantité + infos), vérifiez le récapitulatif puis déposez : votre brouillon est sauvegardé automatiquement.' },
    { selector: '[data-testid="ai-guide-fab"]', title: 'Oracle',
      text: 'Crédits COOP\'ACT, annulation J+30, modèles de combos… posez-moi vos questions POP\'S à tout moment !' },
  ],
  operator: [
    { selector: '[data-testid="logicoop-dashboard"]', title: 'Tableau de bord LOGICOOP',
      text: 'Vos indicateurs : missions en cours, livraisons du jour et rémunération cumulée.' },
    { selector: '[data-testid="logicoop-missions"]', title: 'Missions de transport',
      text: 'Acceptez vos missions, renseignez les températures et clôturez avec la preuve de livraison ePOD.' },
    { selector: '[data-testid="logicoop-exw-zones"]', title: 'Zones EXW',
      text: 'Les zones d’enlèvement départ usine que vous couvrez.' },
    { selector: '[data-testid="ai-guide-fab"]', title: "Oracle",
      text: 'Une question sur un ePOD, un incident température ou votre rémunération ? Je suis là.' },
  ],
  pos: [
    { selector: '[data-testid="scan-input"]', title: 'Scan des retraits',
      text: 'Scannez le QR-code du client ou saisissez son code pour retrouver sa commande instantanément.' },
    { selector: '[data-testid="tab-ready"]', title: 'Commandes prêtes',
      text: 'Les commandes prêtes à être remises aux clients apparaissent ici.' },
    { selector: '[data-testid="ai-guide-fab"]', title: "Oracle",
      text: 'Besoin d’aide sur un encaissement ou un remboursement UC ? Demandez-moi !' },
  ],
  lolo_point: [
    { selector: '[data-testid="manager-performance-section"]', title: 'Performance du point',
      text: 'Suivez le chiffre, les retraits et l’activité de votre Lolo Point.' },
    { selector: '[data-testid="manager-ranking-section"]', title: 'Classement réseau',
      text: 'Votre position dans le réseau LOLODRIVE — motivez votre équipe !' },
    { selector: '[data-testid="ai-guide-fab"]', title: "Oracle",
      text: 'Réassorts B2B, réception clients, statistiques : je réponds à toutes vos questions.' },
  ],
};
